/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AssignProfileRoleRequest } from '../models/AssignProfileRoleRequest';
import type { AssignProfileRoleResponse } from '../models/AssignProfileRoleResponse';
import type { CreatePermissionRequest } from '../models/CreatePermissionRequest';
import type { CreatePermissionResponse } from '../models/CreatePermissionResponse';
import type { CreateProfileRequest } from '../models/CreateProfileRequest';
import type { GetPermissionResponse } from '../models/GetPermissionResponse';
import type { GetPermissionsListResponse } from '../models/GetPermissionsListResponse';
import type { GetProfileResponse } from '../models/GetProfileResponse';
import type { GetProfileRoleListResponse } from '../models/GetProfileRoleListResponse';
import type { GetProfilesListResponse } from '../models/GetProfilesListResponse';
import type { ListSortDirection } from '../models/ListSortDirection';
import type { SetPasswordSignInStatusRequest } from '../models/SetPasswordSignInStatusRequest';
import type { UpdatePermissionRequest } from '../models/UpdatePermissionRequest';
import type { UpdatePermissionResponse } from '../models/UpdatePermissionResponse';
import type { UpdateProfileRequest } from '../models/UpdateProfileRequest';
import type { UpdateProfileResponse } from '../models/UpdateProfileResponse';
import type { UpdateProfileRolesRequest } from '../models/UpdateProfileRolesRequest';
import type { UpdateProfileRolesResponse } from '../models/UpdateProfileRolesResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class IdentityService {
    /**
     * Updates roles of an user profile.
     * Updates roles of a specified user profile
     * @param id
     * @param requestBody
     * @returns UpdateProfileRolesResponse Success
     * @throws ApiError
     */
    public static updateProfileRolesEndpoint(
        id: string,
        requestBody: UpdateProfileRolesRequest,
    ): CancelablePromise<UpdateProfileRolesResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/profiles/{id}/roles',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Permission is not authorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * User roles list.
     * Retrieves the list of user roles for the current user.
     * @param id
     * @returns GetProfileRoleListResponse Success
     * @throws ApiError
     */
    public static getProfileRoleListEndpoint(
        id: string,
    ): CancelablePromise<GetProfileRoleListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/profiles/{id}/roles',
            path: {
                'id': id,
            },
            errors: {
                401: `User is not authorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * Updates user profile.
     * Updates an existent user profile data.
     * @param id
     * @param requestBody
     * @returns UpdateProfileResponse Success
     * @throws ApiError
     */
    public static updateProfileEndpoint(
        id: string,
        requestBody: UpdateProfileRequest,
    ): CancelablePromise<UpdateProfileResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/profiles/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation failed.`,
                401: `Permission is not authorized`,
            },
        });
    }
    /**
     * User profile.
     * Gets the profile information of the specified user.
     * @param id
     * @returns GetProfileResponse Success
     * @throws ApiError
     */
    public static getProfileEndpoint(
        id: string,
    ): CancelablePromise<GetProfileResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/profiles/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `User is not authorized`,
            },
        });
    }
    /**
     * Deletes a user profile.
     * Deletes an existent user profile data.
     * @param id
     * @returns void
     * @throws ApiError
     */
    public static deleteProfileEndpoint(
        id: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/profiles/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Not authorized.`,
                404: `Not found.`,
            },
        });
    }
    /**
     * Removes a role from a user profile.
     * Removes a role from a specified user profile
     * @param id
     * @param roleId
     * @returns void
     * @throws ApiError
     */
    public static deleteProfileRoleEndpoint(
        id: string,
        roleId: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/profiles/{id}/roles/{roleId}',
            path: {
                'id': id,
                'roleId': roleId,
            },
            errors: {
                401: `Not authorized.`,
                403: `Forbidden`,
                404: `Not found.`,
            },
        });
    }
    /**
     * Assigns a role to a user profile.
     * Assigns a specified role to a given user profile within a legal entity.
     * @param id The unique identifier of the user profile to which the role will be assigned.
     * @param roleId The unique identifier of the role to be assigned.
     * @param requestBody
     * @returns AssignProfileRoleResponse The role has been successfully assigned to the user profile.
     * @throws ApiError
     */
    public static assignProfileRoleEndpoint(
        id: string,
        roleId: string,
        requestBody: AssignProfileRoleRequest,
    ): CancelablePromise<AssignProfileRoleResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/profiles/{id}/roles/{roleId}',
            path: {
                'id': id,
                'roleId': roleId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The request parameters are invalid or incomplete.`,
                401: `The user is not authorized to perform this action.`,
                403: `Forbidden`,
                404: `The specified user profile, role, or legal entity was not found.`,
            },
        });
    }
    /**
     * Creates user profile.
     * Creates a new user profile with personal, contact, and address details.
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static createProfileEndpoint(
        requestBody: CreateProfileRequest,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/profiles',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation failed.`,
                401: `User is not authorized.`,
                409: `A user profile with the provided IDNP or email already exists.`,
            },
        });
    }
    /**
     * User profile list.
     * Gets the list of registered user profiles.
     * @param pageNumber
     * @param pageSize
     * @param searchTerm
     * @param role
     * @param legalEntity
     * @param hasMPassConnection
     * @param sortBy
     * @param sortDirection
     * @param permissionKeys
     * @returns GetProfilesListResponse Success
     * @throws ApiError
     */
    public static getProfilesListEndpoint(
        pageNumber: number,
        pageSize: number,
        searchTerm?: string | null,
        role?: string | null,
        legalEntity?: string | null,
        hasMPassConnection?: boolean | null,
        sortBy?: string | null,
        sortDirection?: ListSortDirection | null,
        permissionKeys?: Array<string> | null,
    ): CancelablePromise<GetProfilesListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/profiles',
            query: {
                'searchTerm': searchTerm,
                'role': role,
                'legalEntity': legalEntity,
                'hasMPassConnection': hasMPassConnection,
                'sortBy': sortBy,
                'sortDirection': sortDirection,
                'pageNumber': pageNumber,
                'pageSize': pageSize,
                'permissionKeys': permissionKeys,
            },
            errors: {
                400: `Bad Request`,
                401: `User is not authorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @deprecated
     * Updates permission.
     * Updates an existent permission.
     * @param id
     * @param requestBody
     * @returns UpdatePermissionResponse Success
     * @throws ApiError
     */
    public static updatePermissionEndpoint(
        id: string,
        requestBody: UpdatePermissionRequest,
    ): CancelablePromise<UpdatePermissionResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/permissions/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation failed.`,
                401: `Permission is not authorized`,
            },
        });
    }
    /**
     * Permission.
     * Gets an instance of user permission.
     * @param id
     * @returns GetPermissionResponse Success
     * @throws ApiError
     */
    public static getPermissionEndpoint(
        id: string,
    ): CancelablePromise<GetPermissionResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/permissions/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `User is not authorized`,
            },
        });
    }
    /**
     * List of permissions.
     * Gets a list o all the system permissions.
     * @returns GetPermissionsListResponse Success
     * @throws ApiError
     */
    public static getPermissionsListEndpoint(): CancelablePromise<GetPermissionsListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/permissions',
            errors: {
                401: `User is not authorized`,
            },
        });
    }
    /**
     * @deprecated
     * Creates permission.
     * Creates new permission.
     * @param requestBody
     * @returns CreatePermissionResponse Success
     * @throws ApiError
     */
    public static createPermissionEndpoint(
        requestBody: CreatePermissionRequest,
    ): CancelablePromise<CreatePermissionResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/permissions',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation failed.`,
                401: `User is not authorized`,
            },
        });
    }
    /**
     * Enable or disable password sign-in for a user.
     * Allows an admin to enable or disable password authentication for a specific user account.
     * @param userProfileId
     * @param requestBody
     * @returns any Password sign-in status updated successfully.
     * @throws ApiError
     */
    public static setPasswordSignInStatusEndpoint(
        userProfileId: string,
        requestBody: SetPasswordSignInStatusRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/profiles/{userProfileId}/password-signin-status',
            path: {
                'userProfileId': userProfileId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid request or update failed.`,
                401: `Unauthorized`,
                403: `Forbidden to change settings.`,
                404: `User not found.`,
            },
        });
    }
}
